import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/(pages)/company/@section5/page.tsx");
